module.exports = __webpack_public_path__ + "static/media/open-patient-record.204e3bd0.svg";